import { EditProjectContextProps } from "../../../EditProjectContext";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { RoutingType } from "../../../../ViewModel/RoutingType";

export const removePdsrOnThisRouteFromRoutingTable = (
  containerNetwork: string | undefined,
  supplierGsdb: string | undefined,
  plantGsdb: string | undefined,
  dockCode: string | undefined,
  ftlRouteNumber: string | undefined,
  editProjectContext: EditProjectContextProps
) => {
  const { project, setProject } = editProjectContext;
  const route = project.FTLRoutes?.filter(
    (x) => x.RouteNumber === ftlRouteNumber
  )[0] as FtlRouteViewModel;
  if (
    !route ||
    !route.PdsrsOnThisRoute ||
    !route.RoutingTable ||
    !ftlRouteNumber ||
    !supplierGsdb ||
    !plantGsdb ||
    !dockCode
  ) {
    return;
  }
  const pdsrOnThisRoute = route.PdsrsOnThisRoute;

  const pdsrOnThisRouteIndex = route.PdsrsOnThisRoute.findIndex(
    (x) =>
      x.ContainerNetwork === containerNetwork &&
      x.SupplierGsdb === supplierGsdb &&
      x.PlantGsdb === plantGsdb &&
      x.DockCode === dockCode
  );

  if (pdsrOnThisRouteIndex === -1) {
    return;
  }

  pdsrOnThisRoute.splice(pdsrOnThisRouteIndex, 1);

  let returnRoutingTable = route.RoutingTable;

  const isPdsrSupplierOnRoute =
    pdsrOnThisRoute.findIndex((x) => x.SupplierGsdb === supplierGsdb) >= 0;

  if (!isPdsrSupplierOnRoute) {
    returnRoutingTable = returnRoutingTable.filter(
      (x) =>
        !(x.Gsdb === supplierGsdb && x.RoutingType === RoutingType.Supplier)
    );
  }

  const isPdsrPlantDockOnRoute =
    pdsrOnThisRoute.findIndex(
      (x) => x.PlantGsdb === plantGsdb && x.DockCode === dockCode
    ) >= 0;

  if (!isPdsrPlantDockOnRoute) {
    returnRoutingTable = returnRoutingTable.filter(
      (x) => x.DockCode !== dockCode
    );
  }

  const returnReturnFTLRoutes = project.FTLRoutes?.map((routeItem) => {
    if (routeItem.RouteNumber !== ftlRouteNumber) {
      return routeItem;
    }
    return {
      ...routeItem,
      RoutingTable: returnRoutingTable,
    };
  });

  setProject({ ...project, FTLRoutes: returnReturnFTLRoutes });
};
